import React from 'react';

import ButtonLink from '@/components/common/ButtonLink/ButtonLink';
import ToggleOptionTitle from '@/components/common/ToggleOption/ToggleOptionTitle';
import styles from './custom-toggle-title.module.scss';

interface ICustomToggleTitleComponentProps {
  title: string;
  isEnabledToggle: boolean;
  onClose: () => void;
  selectedOptionText: string | null;
  verificationIcon?: React.ReactNode;
}

export default function CustomToggleTitleComponent({
  title,
  onClose,
  isEnabledToggle,
  selectedOptionText,
  verificationIcon,
}: ICustomToggleTitleComponentProps) {
  return (
    <div className="d-flex flex-column">
      <div>
        <ToggleOptionTitle>{title}</ToggleOptionTitle>
        {verificationIcon}

        {isEnabledToggle && (
          <ButtonLink
            style={{ marginLeft: 10 }}
            onClick={onClose}
          >
            <div className={styles['edit-toggle-btn']}>
              Edit
            </div>
          </ButtonLink>
        )}
      </div>

      {selectedOptionText && (
        <div className={styles['selected-debit-option']}>
          {selectedOptionText}
        </div>
      )}
    </div>
  );
}
